import { z } from "zod";

import { auditDate } from "@/schemas";

import { environmentalChecklistItemWithTicket } from "../../../../schemas";

export const moveInMoveOutKitchenSchema = z.object({
  auditDate: auditDate,
  locationId: z.string().min(1, "Required"),
  reviewerId: z.string().min(1, "Required"),
  kitchenStove: environmentalChecklistItemWithTicket,
  kitchenDrainboard: environmentalChecklistItemWithTicket,
  kitchenSink: environmentalChecklistItemWithTicket,
  kitchenFixture: environmentalChecklistItemWithTicket,
  kitchenFloor: environmentalChecklistItemWithTicket,
  kitchenCeiling: environmentalChecklistItemWithTicket,
  kitchenDoor: environmentalChecklistItemWithTicket,
  kitchenRefrigerator: environmentalChecklistItemWithTicket,
  kitchenOther: environmentalChecklistItemWithTicket,
  kitchenCabinets: environmentalChecklistItemWithTicket,
  kitchenWall: environmentalChecklistItemWithTicket,
  kitchenComment: z.string().optional(),
});
